export default function CPUIcon() {
  return (
    <svg width='54px' height='59px' viewBox='0 0 54 59' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <title>cpu</title>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='cpu'>
          <circle id='Oval-Copy-21' fill='#000000' transform='translate(27.000000, 27.000000) scale(-1, 1) translate(-27.000000, -27.000000) ' cx='27' cy='27' r='27'></circle>
          <circle id='Oval-Copy-40' fill='#000000' transform='translate(27.000000, 32.000000) scale(-1, 1) translate(-27.000000, -32.000000) ' cx='27' cy='32' r='27'></circle>
          <circle fill='#FFCE67' transform='translate(27.000000, 27.000000) scale(-1, 1) translate(-27.000000, -27.000000) ' cx='27' cy='27' r='24'></circle>
          <g transform='translate(15.000000, 18.000000)' stroke='#000000' strokeWidth='3'>
            <g id='Group-10'>
              <line x1='14.5' y1='0.5' x2='20.5' y2='0.5'></line>
              <line x1='3.5' y1='0.5' x2='9.5' y2='0.5'></line>
              <line x1='0' y1='7.5' x2='24' y2='7.5'></line>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
